"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect/APSelect"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _APDatePicker = _interopRequireDefault(require("../../common/APDatePicker/APDatePicker"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _ProductIconContainer = _interopRequireDefault(require("../../common/ProductIcon/ProductIconContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _get = _interopRequireDefault(require("lodash/get"));
require("./AssetActivityDetailsHeaderComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('asset-activity-details-header');
var AssetActivityDetailsHeaderComponent = function AssetActivityDetailsHeaderComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  var product = props.product,
    productManifest = props.productManifest,
    selectPositionAndSave = props.selectPositionAndSave,
    handleSubmit = props.handleSubmit,
    clearDate = props.clearDate,
    formObj = props.formObj,
    setEndDate = props.setEndDate,
    buttonBackLink = props.buttonBackLink,
    clearFilters = props.clearFilters,
    startDate = props.startDate,
    endDate = props.endDate;
  var selectedProduct = product && product.products.find(function (p) {
    return p.ProductId.toString() === "".concat((0, _get["default"])(formObj, 'values.product')).toString();
  });
  var productOptions = product && product.products.map(function (product) {
    var ProductId = product.ProductId,
      Product = product.Product,
      ProductFullName = product.ProductFullName;
    return {
      value: ProductId,
      label: "".concat(Product, " ").concat(ProductFullName)
    };
  });
  productOptions.unshift({
    value: 'All',
    label: 'All Products'
  });
  var productSelectorStyleOptions = ['product'];
  if (!selectedProduct) {
    productSelectorStyleOptions.push('without-icon');
  }
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: bemClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('left-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('button-back-container')
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _path["default"])(buttonBackLink)
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowPrevious",
    customClass: bemClasses()
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('selector-container', productSelectorStyleOptions)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('product-icon')
  }, productManifest.manifest && selectedProduct && /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    size: 20,
    iconFileName: Object.keys(productManifest.manifest).indexOf(selectedProduct.Product) === -1 ? selectedProduct.Product + 'DEFAULT_ICON' : productManifest.manifest[selectedProduct.Product].iconFileName
  })), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "product",
    onSelect: function onSelect(value) {
      return selectPositionAndSave(parseInt(value, 10));
    },
    customClass: bemClasses(),
    showTriangles: true,
    options: productOptions
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('right-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('date-pickers-container')
  }, /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "startDate",
    customClass: bemClasses('from'),
    label: t('Date range:'),
    format: function format(value) {
      return value;
    },
    maxDate: endDate || new Date(),
    showIcon: true,
    iconClick: function iconClick() {
      return clearDate('startDate');
    },
    customChange: function customChange() {
      if (!endDate) {
        setEndDate(new Date());
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
    name: "endDate",
    customClass: bemClasses('to'),
    label: t('to'),
    format: function format(value) {
      return value;
    },
    minDate: startDate,
    maxDate: new Date(),
    showIcon: true,
    iconClick: function iconClick() {
      return clearDate('endDate');
    }
  }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: bemClasses('clear'),
    type: "button",
    onClick: clearFilters
  }, t('Clear Filters'))))));
};
var _default = exports["default"] = AssetActivityDetailsHeaderComponent;